export default __webpack_public_path__ + "static/media/Royal Atlantean Gown.3430db31.jpg";